"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTypography = exports.defaultTypography = void 0;
var breakpoints_1 = require("./breakpoints");
exports.defaultTypography = {
    display1: {
        fontSize: '3.875rem',
        lineHeight: '1.13',
        responsive: (_a = {},
            _a["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '2.875rem',
                lineHeight: '1.17',
            },
            _a),
    },
    display2: {
        fontSize: '3.25rem',
        lineHeight: '1.19',
        responsive: (_b = {},
            _b["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '2.625rem',
                lineHeight: '1.24',
            },
            _b),
    },
    h1: {
        fontSize: '2.625rem',
        lineHeight: '1.24',
        responsive: (_c = {},
            _c["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '2.25rem',
                lineHeight: '1.28',
            },
            _c),
    },
    h2: {
        fontSize: '2.25rem',
        lineHeight: '1.28',
        responsive: (_d = {},
            _d["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '2rem',
                lineHeight: '1.31',
            },
            _d),
    },
    h3: {
        fontSize: '2rem',
        lineHeight: '1.31',
        responsive: (_e = {},
            _e["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '1.75rem',
                lineHeight: '1.36',
            },
            _e),
    },
    h4: {
        fontSize: '1.5rem',
        lineHeight: '1.33',
        responsive: (_f = {},
            _f["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '1.5rem',
            },
            _f),
    },
    h5: {
        fontSize: '1.375rem',
        lineHeight: '1.3',
        responsive: (_g = {},
            _g["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '1.375rem',
                lineHeight: '1.36',
            },
            _g),
    },
    h6: {
        fontSize: '1.25rem',
        lineHeight: '1.4',
    },
    subtitle1: {
        fontSize: '1.125rem',
        lineHeight: '1.44',
    },
    subtitle2: {
        fontSize: '1rem',
        lineHeight: '1.5',
    },
    body1: {
        fontSize: '1rem',
        lineHeight: '1.5',
    },
    body2: {
        fontSize: '0.875rem',
        lineHeight: '1.57',
    },
    caption: {
        fontSize: '0.75rem',
        lineHeight: '1.67',
    },
    link: {
        fontSize: '1rem',
        lineHeight: '1.5',
    },
};
// TODO: setup deepmerge
function createTypography(typograghyInput) {
    console.log(typograghyInput);
    return exports.defaultTypography;
}
exports.createTypography = createTypography;
//# sourceMappingURL=typography.js.map